import Modal from "react-modal";
import { ModalTitle } from "styles/Modal";
import closeImg from "../../assets/close.svg";
import { FieldValues, SubmitHandler, useForm } from "react-hook-form";
import { InputGroup } from "styles/InputGroup";
import { Button } from "styles/Button";
import { Form } from "styles/Form";
import { Buttons } from "components/MessageForm/styles";
import { Input } from "components/Form/Input";
import { useAddSupportAgent } from "hooks/mutations/useAddSupportAgent";
import { useUsers } from "hooks/fetch/useUsers";
import { SelectField } from "components/AddAbsenceModal/styles";

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
  categoryId: string;
};

export function AddSupportAgentModal({ isOpen, onRequestClose, categoryId }: Props) {
  const { handleSubmit, register, control, reset, formState: { isSubmitting } } = useForm<FieldValues>({
    defaultValues: { user_id: '', weight: 1 },
  });

  const addAgent = useAddSupportAgent();
  const { query: { data: usersData } } = useUsers('/users');

  const allUsers = (usersData?.pages?.flatMap(p => p.data) ?? []).filter(u => u.default_category_id === categoryId);

  function handleClose() {
    reset();
    onRequestClose();
  }

  async function handleSubmitForm({ user_id, weight }: any) {
    await addAgent.mutateAsync({ user_id, weight: Number(weight) });
    handleClose();
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      overlayClassName="react-modal-overlay"
      className="react-modal-content"
    >
      <button type="button" onClick={handleClose} className="react-modal-close">
        <img src={closeImg} alt="Fechar modal" loading="lazy" />
      </button>

      <div>
        <ModalTitle>Adicionar agente ao rodízio</ModalTitle>
        <Form onSubmit={handleSubmit(handleSubmitForm as SubmitHandler<FieldValues>)}>
          <SelectField id="user_id" {...register('user_id', { required: true })}>
            <option value="">Selecione um atendente...</option>
            {allUsers.map(user => (
              <option key={user.id} value={user.id}>{user.name}</option>
            ))}
          </SelectField>

          <InputGroup>
            <Input
              control={control}
              type="number"
              name="weight"
              id="weight"
              label="Peso (1–100)"
              min={1}
              max={100}
              fullwidth
            />
          </InputGroup>

          <InputGroup>
            <Buttons>
              <Button type="submit" fullwidth disabled={isSubmitting}>
                {isSubmitting ? 'Adicionando...' : 'Adicionar'}
              </Button>
              <Button type="button" onClick={handleClose}>Cancelar</Button>
            </Buttons>
          </InputGroup>
        </Form>
      </div>
    </Modal>
  );
}
